<template>
    <span v-if="mostrarIcone">
        <span class="text-warning ml-1">
            <i
                class="fa fa-question-circle fa-lg icon-button"
                title="Detalhe do Erro no Comprometimento"
                @click.stop="mostrarDetalhe()"
            ></i>
        </span>
        <b-modal
            id="modalDetalhe"
            v-model="mostrarModalDetalhe"
            @show="obterErroComprometimento()"
        >
            <div slot="modal-title">Detalhe do Erro no Comprometimento</div>
            <b-row>
                <b-col sm="12">
                    <b-form-group>
                        <label for="contato">Mensagem</label>
                        <b-form-textarea
                            v-model="mensagem"
                            :rows="4"
                            :disabled="true"
                        ></b-form-textarea>
                    </b-form-group>
                </b-col>
            </b-row>
            <div slot="modal-footer">
                <b-button variant="secondary" @click.stop="fecharDetalhe()"
                    >Fechar</b-button
                >
            </div>
        </b-modal>
    </span>
</template>

<script>
import { comprometimentoStatus } from '../ComprometimentoStatus'

export default {
    props: {
        entrega: {
            type: Object,
            default: () => ({})
        },

        movimentosServicos: {
            type: Object,
            default: () => ({})
        }
    },

    data() {
        return {
            mostrarModalDetalhe: false,
            mensagem: ''
        }
    },

    methods: {
        obterErroComprometimento() {
            this.$store.dispatch('addRequest')
            this.movimentosServicos
                .obterErroComprometimentoEntrega(this.entrega.entregaId)
                .then(response => {
                    if (response) {
                        if (response.success) {
                            this.mensagem = response.data
                        } else {
                            this.$toast.error(
                                'Erro ao obter erro comprometimento!!!',
                                'ERROR',
                                this.$toastConfig.error
                            )
                        }
                    }
                    this.$store.dispatch('removeRequest')
                })
        },

        mostrarDetalhe() {
            this.mostrarModalDetalhe = true
        },

        fecharDetalhe() {
            this.mostrarModalDetalhe = false
        }
    },

    computed: {
        mostrarIcone() {
            return (
                (this.$temAcessoView('CRED-UABS-CONT-01') ||
                    this.$temAcessoView('CRED-GEST-CONT-01')) &&
                this.entrega.statusIdRm == comprometimentoStatus.ERRO
            )
        }
    }
}
</script>
